import { seedCleanupTranscriptSchema } from './shared/seedCleanupTranscriptSchema';

/**
 * Package init: registers podcast analysis/output schemas.
 */
export default function init(): void {
  seedCleanupTranscriptSchema();
}
